import _Typography from "@mui/material/Typography";
import _Accordion from "@mui/material/Accordion";
import _AccordionDetails from "@mui/material/AccordionDetails";
import _AccordionSummary from "@mui/material/AccordionSummary";
import _FormControlLabel from "@mui/material/FormControlLabel";
import _Switch from "@mui/material/Switch";
import _InfoOutlined from "@mui/icons-material/InfoOutlined";
import _ExpandMore from "@mui/icons-material/ExpandMore";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
import { FacilitiesLegend } from './facilities-legend';
export function FacilitiesToggle({
  facilitiesShowed,
  selectedFacilities,
  toggleFacilities,
  ...props
}) {
  const [expended, expend] = useState(false);
  return /*#__PURE__*/React.createElement(_Accordion, _extends({
    expanded: expended,
    onChange: () => expend(!expended)
  }, props, {
    sx: {
      borderRadius: '16px !important',
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 'calc(100% - 16px)',
      pointerEvents: 'initial',
      width: 360,
      '&&': {
        '.MuiCollapse-root.MuiCollapse-entered': {
          flexGrow: 1,
          overflowY: 'auto !important'
        }
      },
      ...props.sx
    }
  }), /*#__PURE__*/React.createElement(_AccordionSummary, {
    "aria-controls": "facilities-legend",
    "aria-label": "Expand",
    expandIcon: expended ? /*#__PURE__*/React.createElement(_ExpandMore, null) : /*#__PURE__*/React.createElement(_InfoOutlined, null),
    id: "facilities-header",
    sx: {
      '&&': {
        '&.Mui-expanded': {
          flexShrink: 0,
          minHeight: 48
        },
        '.MuiAccordionSummary-content.Mui-expanded': {
          margin: '12px 0'
        }
      }
    }
  }, /*#__PURE__*/React.createElement(_FormControlLabel, {
    "aria-label": "Enable",
    control: /*#__PURE__*/React.createElement(_Switch, {
      checked: facilitiesShowed,
      color: "primary",
      size: "small"
    }),
    label: /*#__PURE__*/React.createElement(StyledAccordionSummaryLabel, null, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.facilities_label"
    })),
    onChange: (_, showed) => {
      try {
        localStorage.setItem('display_facilities', showed ? 'true' : 'false');
      } catch {
        console.error('localStorage access is denied');
      }
      toggleFacilities(showed);
    },
    onClick: event => event.stopPropagation(),
    onFocus: event => event.stopPropagation(),
    value: facilitiesShowed
  })), /*#__PURE__*/React.createElement(_AccordionDetails, null, /*#__PURE__*/React.createElement(FacilitiesLegend, {
    enableDescriptions: true,
    selectedFacilities: selectedFacilities
  })));
}
const StyledAccordionSummaryLabel = styled(_Typography)`
  && {
    margin-left: 8px;
  }
`;